import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { CSSTransitionGroup } from 'react-transition-group';
import { connect } from 'react-redux';
import { hideMessage } from '../../actions/hide-message';
import Message from '../../components/message';
import ScrollListener from '../../components/scroll-listener';
import withDeviceType from '../../hoc/with-device-type';
import { isOneAppSearchParam } from '@wix/communities-blog-client-common';
import Wix from '../../services/wix-sdk-polyfill';

const SHOW_TIMEOUT = 100;
const HIDE_TIMEOUT = SHOW_TIMEOUT + 3000;
const ANIMATION_ENTER_TIMEOUT = 50;
const ANIMATION_LEAVE_TIMEOUT = 400;

export class MessageRoot extends Component {
  state = {
    showMessage: false,
    top: 0,
  };

  clearTimeouts = () => {
    this.showTimeout && clearTimeout(this.showTimeout);
    this.hideTimeout && clearTimeout(this.hideTimeout);
    this.setState({ showMessage: false });
  };

  componentWillReceiveProps(nextProps) {
    const { type } = this.props;
    // TODO: implement this using middleware or something
    if (type !== nextProps.type) {
      this.clearTimeouts();
      this.showTimeout = setTimeout(this.showMessage, SHOW_TIMEOUT);
      this.hideTimeout = setTimeout(this.hideMessage, HIDE_TIMEOUT);
    }
  }

  showMessage = () => {
    this.showTimeout = undefined;

    if (this.props.isOneApp) {
      this.setState({ showMessage: true });
    } else {
      Wix.getBoundingRectAndOffsets(({ rect }) => {
        this.setState({
          showMessage: true,
          top: Math.abs(Math.min(0, rect.top)),
        });
      });
    }
  };

  hideMessage = () => {
    this.props.hideMessage();
    this.hideTimeout = undefined;
    this.setState({ showMessage: false });
  };

  handleScroll = (scroll) => {
    const { scroll: { scrollTop, height } = {} } = this.state;
    if (this.hideTimeout && scrollTop !== scroll.scrollTop && scroll.scrollTop !== 0 && height === scroll.height) {
      this.clearTimeouts();
      this.hideMessage();
    }
    this.setState({ scroll });
  };

  renderMessage() {
    const { type, content, hideMessage, alignment, isInBackOffice, showCloseButton } = this.props;
    const { top } = this.state;

    const messageProps = {
      type,
      content,
      top,
      alignment,
      isInBackOffice,
      onClose: showCloseButton ? hideMessage : null,
    };
    return <Message {...messageProps} />;
  }

  render() {
    const { content } = this.props;
    const { showMessage } = this.state;

    return (
      <CSSTransitionGroup
        component="div"
        transitionName="message"
        transitionEnterTimeout={ANIMATION_ENTER_TIMEOUT}
        transitionLeaveTimeout={ANIMATION_LEAVE_TIMEOUT}
      >
        {content && showMessage ? this.renderMessage() : null}
        <ScrollListener onScroll={this.handleScroll} />
      </CSSTransitionGroup>
    );
  }
}

MessageRoot.propTypes = {
  hideMessage: PropTypes.func.isRequired,
  type: PropTypes.string,
  content: PropTypes.any,
  isDesktop: PropTypes.bool,
  isMobile: PropTypes.bool,
  scroll: PropTypes.object,
  alignment: PropTypes.string,
  showCloseButton: PropTypes.bool,
  isInBackOffice: PropTypes.bool,
  isOneApp: PropTypes.bool,
};

MessageRoot.defaultProps = {
  showCloseButton: true,
  isInBackOffice: false,
};

const mapStateToProps = (state) => ({
  type: state.message.type,
  content: state.message.content,
  isOneApp: isOneAppSearchParam(state),
});

const mapDispatchToProps = {
  hideMessage,
};

// prettier-ignore
export default flowRight(
  connect(mapStateToProps, mapDispatchToProps),
  withDeviceType
)(MessageRoot);
